// // utils/tabFieldMapper.js

import {
  formatRecentlyAddedMemberDisplayName,
  formatDashboardMemorialMemberDisplayName,
  formatDashboardUpcomingCoupleName,
} from "./dashboardMemberDisplayName";
import { convertUTCToDateInvitation, formatMsToMMDDYYYY } from "./dateUtils";

// Helper function to convert date string to MM/DD/YYYY format
// Used for cases where we receive a date string that might be in different formats
const convertToMMDDYYYY = (dateString) => {
  if (!dateString || dateString === '-' || dateString === 'N/A') return dateString;
  
  // If already in MM/DD/YYYY format (pattern matches), verify and return
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const firstPart = parseInt(parts[0], 10);
      const secondPart = parseInt(parts[1], 10);
      // If first part is > 12 and second part <= 12, it's DD/MM/YYYY, so swap
      if (firstPart > 12 && secondPart <= 12) {
        return `${parts[1]}/${parts[0]}/${parts[2]}`;
      }
      // Otherwise assume it's already MM/DD/YYYY
      return dateString;
    }
  }
  
  // Try to parse as DD/MM/YYYY and convert
  const parts = dateString.split('/');
  if (parts.length === 3) {
    const [day, month, year] = parts;
    return `${month}/${day}/${year}`;
  }
  
  return dateString;
};

/** Years since passing on the next memorial anniversary (UTC calendar dates). */
const getYearsSincePassingOnUpcomingAnniversary = (deathValue) => {
  let ms = typeof deathValue === "string" ? parseInt(deathValue, 10) : deathValue;
  if (ms == null || isNaN(ms)) return null;
  const death = new Date(ms);
  if (isNaN(death.getTime())) return null;
  const deathYear = death.getUTCFullYear();
  const m = death.getUTCMonth();
  const d = death.getUTCDate();
  const now = new Date();
  let annivYear = now.getUTCFullYear();
  const todayStart = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  const thisYearAnniv = Date.UTC(annivYear, m, d);
  if (todayStart > thisYearAnniv) annivYear += 1;
  const years = annivYear - deathYear;
  return years >= 0 ? years : null;
};

// /**
//  * Get field mappings for each tab type
//  * @param {string} activeTab - 'birthdays', 'anniversaries', 'events', or 'memorials'
//  * @returns {Object} Object containing label and field name for each section
//  */
// export const getTabFieldMappings = (activeTab) => {
//     const mappings = {
//       // BIRTHDAYS
//       birthdays: {
//         name: { label: "Name:", field: "name" },
//         date: { 
//           label: "DOB:", 
//           field: "dob",
//           format: (value, item) => {
//             const formattedDate = msToDate(value); // assuming msToDate is available
//             const turningAge = item.turning_age !== undefined ? ` (Turning ${item.turning_age})` : '';
//             return `${formattedDate}${turningAge}`;
//           }
//         },
//         relation: { label: "Relation:", field: "relation" },
//         family: { 
//           label: "Family:", 
//           field: (item) => `${item.family_tree_title || ''} ${item.family_line_color || ''}`.trim() 
//         },
//         color: { 
//           label: "Line/Color:", 
//           field: "family_line_color" 
//         },
//         image: { field: "image" },
//         showRSVP: false
//       },
      
//       // ANNIVERSARIES
//       anniversaries: {
//         name: { label: "Name:", field: "couple_name" },
//         date: { 
//           label: "DOB:", 
//           field: "wedding_anniversary",
//           format: (value, item) => {
//             const formattedDate = msToDate(value);
//             const anniversaryText = item.anniversary_text ? ` (${item.anniversary_text})` : '';
//             return `${formattedDate}${anniversaryText}`;
//           }
//         },
//         relation: { label: "Relation:", field: "relation" },
//         family: { 
//           label: "Family:", 
//           field: (item) => `${item.family_tree_title || ''} ${item.family_line_color || ''}`.trim() 
//         },
//         color: { 
//           label: "Line/Color:", 
//           field: "family_line_color" 
//         },
//         image: { field: "member_image" },
//         showRSVP: false
//       },
      
//       // EVENTS
//       events: {
//         name: { label: "Host Family Line & Color:", field: "name" },
//         date: { label: "Date:", field: "date" },
//         relation: { 
//           label: "Time:", 
//           field: () => new Date().toLocaleTimeString() 
//         },
//         family: { label: "Location:", field: "location" },
//         color: { label: "Theme:", field: "theme" },
//         image: { field: "image" },
//         showRSVP: true
//       },
      
//       // MEMORIALS (if needed)
//       memorials: {
//         name: { label: "Name:", field: "name" },
//         date: { 
//           label: "Date of Passing:", 
//           field: "date_of_death",
//           format: (value) => msToDate(value)
//         },
//         relation: { label: "Relation:", field: "relation" },
//         family: { 
//           label: "Family:", 
//           field: (item) => `${item.family_tree_title || ''} ${item.family_line_color || ''}`.trim() 
//         },
//         color: { 
//           label: "Line/Color:", 
//           field: "family_line_color" 
//         },
//         image: { field: "image" },
//         showRSVP: false
//       }
//     };
  
//     return mappings[activeTab] || mappings.birthdays;
//   };
  
//   /**
//    * Helper to get field value from item
//    * @param {Object} item - Data item
//    * @param {string|Function} field - Field name or function
//    * @returns {*} Field value
//    */
//   export const getFieldValue = (item, field, formatFn) => {
//     if (typeof field === 'function') {
//       return field(item);
//     }
//     const value = item?.[field];
    
//     if (formatFn && value !== undefined) {
//       return formatFn(value, item);
//     }
    
//     return value || "N/A";
//   };


// utils/tabFieldMapper.js

/**
 * Get field mappings for each tab type
 * @param {string} activeTab - 'birthdays', 'anniversaries', 'events', or 'memorials'
 * @returns {Object} Object containing label and field name for each section
 */
export const getTabFieldMappings = (activeTab) => {
    const mappings = {
      // BIRTHDAYS
      birthdays: {
        name: {
          label: "Name:",
          field: (item) => formatRecentlyAddedMemberDisplayName(item),
        },
        date: { 
          label: "DOB:", 
          field: "dob",
          format: (value) => formatMsToMMDDYYYY(value) || "-",
        },
        relation: { label: "Relation:", field: "relation" },
        // COMBINED Family Line/Color into one
        familyColor: { 
          label: "Family Line/Color:", 
          field: (item) => {
            const family = item.family_tree_title || '';
            const color = item.family_line_color || '';
            if (family && color) return `${family} ${color}`.trim();
            if (family) return family;
            if (color) return color;
            return "N/A";
          }
        },
        // Removed separate color field
        image: { field: "image" },
        showRSVP: false,
        showExtraField: false // No extra field for birthdays
      },
      
      // ANNIVERSARIES
      anniversaries: {
        name: {
          label: "Name:",
          field: (item) => formatDashboardUpcomingCoupleName(item),
        },
        date: { 
          label: "Wedding Date:", 
          field: "wedding_anniversary",
          format: (value, item) => {
            const formattedDate = formatMsToMMDDYYYY(value) || "-";
            const anniversaryLabel = item.anniversary_text
              ? String(item.anniversary_text).replace(/\bAnniversary\b/gi, "Anniv")
              : "";
            const anniversaryText = anniversaryLabel ? ` (${anniversaryLabel})` : "";
            return `${formattedDate}${anniversaryText}`;
          }
        },
        relation: { label: "Relation:", field: "relation" },
        // COMBINED Family Line/Color into one
        familyColor: { 
          label: "Family Line/Color:", 
          field: (item) => {
            const family = item.family_tree_title || '';
            const color = item.family_line_color || '';
            if (family && color) return `${family} ${color}`.trim();
            if (family) return family;
            if (color) return color;
            return "N/A";
          }
        },
        // Removed separate color field
        image: { field: "member_image" },
        showRSVP: false,
        showExtraField: false // No extra field for anniversaries
      },
      
      // EVENTS (Host, Family color, Event Name, Event Date)
      events: {
        name: {
          label: "Host:",
          field: (item) => {
            const first = item?.host_first_name || "";
            const last = item?.host_last_name || "";
            const special = item?.host_special_name || "";
            const suffix = item?.host_suffix || "";
            const parts = [first, special, last].filter(Boolean);
            let name = parts.join(" ").trim();
            if (suffix) name = name ? `${name}, ${suffix}.` : `${suffix}.`;
            return name || "N/A";
          }
        },
        familyColor: { label: "Family color:", field: "host_color_name" },
        eventName: { label: "Event Name:", field: "title" },
        date: {
          label: "Event Date:",
          field: "start_date",
          format: (value) => convertUTCToDateInvitation(value) || "-"
        },
        image: { field: "image" },
        showRSVP: false,
        showExtraField: false
      },
      
      // MEMORIALS (if needed)
      memorials: {
        name: {
          label: "Name:",
          // Women are remembered under first + maiden name ("Frances Patterson").
          field: (item) => formatDashboardMemorialMemberDisplayName(item),
        },
        date: { 
          label: "Date of Passing:", 
          field: (item) =>
            item?.date_of_death ?? item?.date_of_passing ?? item?.dateOfDeath,
          format: (raw) => {
            const formattedDate = formatMsToMMDDYYYY(raw) || "-";
            const years = getYearsSincePassingOnUpcomingAnniversary(raw);
            const yearsPart =
              years != null
                ? ` (${years} year${years === 1 ? "" : "s"})`
                : "";
            return `${formattedDate}${yearsPart}`;
          }
        },
        relation: { label: "Relation:", field: "relation" },
        // COMBINED Family Line/Color into one
        familyColor: { 
          label: "Family Line/Color:", 
          field: (item) => {
            const family = item.family_tree_title || '';
            const color = item.family_line_color || '';
            if (family && color) return `${family} ${color}`.trim();
            if (family) return family;
            if (color) return color;
            return "N/A";
          }
        },
        // Removed separate color field
        image: { field: "image" },
        showRSVP: false,
        showExtraField: false // No extra field for memorials
      },
      
      // AGES MILESTONE
      ages_milestone: {
        name: {
          label: "Name:",
          field: (item) => formatRecentlyAddedMemberDisplayName(item),
        },
        date: { 
          label: "DOB:", 
          field: "dob",
          format: (value, item) => {
            const formattedDate = formatMsToMMDDYYYY(value) || "-";
            const milestoneAge = item.milestone_age !== undefined ? ` (Turning ${item.milestone_age})` : '';
            return `${formattedDate}${milestoneAge}`;
          }
        },
        relation: { label: "Relation:", field: "relation" },
        familyColor: { 
          label: "Family Line/Color:", 
          field: (item) => {
            const family = item.family_tree_title || '';
            const color = item.family_line_color || '';
            if (family && color) return `${family} ${color}`.trim();
            if (family) return family;
            if (color) return color;
            return "N/A";
          }
        },
        image: { field: "image" },
        showRSVP: false,
        showExtraField: false
      },
      
      // DUMMY TAB (placeholder for future use)
      dummy: {
        name: { label: "Name:", field: "name" },
        date: { label: "Date:", field: "date" },
        relation: { label: "Relation:", field: "relation" },
        familyColor: { 
          label: "Family Line/Color:", 
          field: (item) => {
            const family = item.family_tree_title || '';
            const color = item.family_line_color || '';
            if (family && color) return `${family} ${color}`.trim();
            if (family) return family;
            if (color) return color;
            return "N/A";
          }
        },
        image: { field: "image" },
        showRSVP: false,
        showExtraField: false
      }
    };
  
    return mappings[activeTab] || mappings.birthdays;
  };
  
  /**
   * Helper to get field value from item
   * @param {Object} item - Data item
   * @param {string|Function} field - Field name or function
   * @returns {*} Field value
   */
  export const getFieldValue = (item, field, formatFn) => {
    if (!item) return "N/A";
    
    if (typeof field === 'function') {
      const result = field(item);
      if (result === undefined || result === null || result === "") {
        return "N/A";
      }
      if (formatFn) {
        return formatFn(result, item);
      }
      return result;
    }
    
    const value = item[field];
    if (value === undefined || value === null) return "N/A";
    
    if (formatFn) {
      return formatFn(value, item);
    }
    
    return value;
  };